import React from 'react'
import AffiliatePartnerRequestComponent from '../../../Components/AdminComponent/AffiliatePartnerRequestComponent/AffiliatePartnerRequestComponent'
import AdminHeader from '../../../Components/AdminComponent/AdminHeader/AdminHeader'
import AdminSidebar from '../../../Components/AdminComponent/AdminSidebar/AdminSidebar'

const AffiliatePartnerRequest = () => {
  return (
  
       <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            <AdminHeader />
            <div className='row col-lg-12'>
                <AdminSidebar />
                <div className='col-lg-10 right_content'>
                    <AffiliatePartnerRequestComponent />
                </div>
            </div>
        </div>

  )
}

export default AffiliatePartnerRequest
